import SparkMD5 from 'spark-md5';
// import {handleDataAndSign} from "@/assets/scripts/handleDataAndSign";

/**
 * 计算文件每个分片的MD5
 * @param file 文件
 * @param chunkSize 分片大小
 * @returns Promise
 */
export function fileSplitFormData(file, chunkSize, url='/admin/testfoo/testApi') {
  return new Promise((resolve, reject) => {
    let chunks = Math.ceil(file.size / chunkSize);
    let chunkCurrent = 0;
    let spark = new SparkMD5.ArrayBuffer();
    let fileReader = new FileReader();
    let currentFile = {};
    let fileInfo = {
      chunks,
      files: []
    };

    fileReader.onload = e => {
      spark.append(e.target.result);
      fileInfo.files.push({md5: spark.end(false), ...currentFile});
      chunkCurrent++;
      if (chunkCurrent < chunks) {
        loadNext();
      } else {
        // let md5 = spark.end();
        resolve(fileInfo);
      }
    };

    fileReader.onerror = function(e) {
      reject(e);
    };

    function loadNext() {
      let start = chunkCurrent * chunkSize;
      let end = start + chunkSize;
      (end > file.size) && (end = file.size);
      let fileSplit = file.slice(start, end);
      let formData = new FormData();
      console.log(url);
      formData.set('file', fileSplit);
      formData.set('dir_id',2);
      currentFile = {
        file: fileSplit,
        chunkCurrent,
        start,
        end,
        formData
      };
      fileReader.readAsArrayBuffer(fileSplit);
    }
    loadNext();
  });
}

/**
 * 计算文件的指定切片段的md5
 * @param file 文件
 * @param start 开始字节
 * @param end 结束字节
 * @returns {Promise<unknown>}
 */
export function fileMd5(file, start = 0, end = 1048576){
  return new Promise((resolve, reject) => {
    let spark = new SparkMD5.ArrayBuffer();
    let fileReader = new FileReader();

    fileReader.onload = e => {
      spark.append(e.target.result);
      resolve(spark.end(false));
    };

    fileReader.onerror = function(e) {
      reject(e);
    };

    fileReader.readAsArrayBuffer(file.slice(start, end));
  })
}
